/**
 * CommentContent - Renders comment text with @[Full Name](user-id) mentions
 * as styled inline tags instead of raw markup.
 */
export default function CommentContent({ content, users }) {
  if (!content) return null;

  // Split content by mention pattern: @[Full Name](user-id)
  const mentionRegex = /@\[([^\]]+)\]\(([^)]+)\)/g;
  const parts = [];
  let lastIndex = 0;
  let match;

  while ((match = mentionRegex.exec(content)) !== null) {
    // Add text before the mention
    if (match.index > lastIndex) {
      parts.push({ type: "text", value: content.slice(lastIndex, match.index) });
    }
    // Add the mention
    const fullName = match[1];
    const userId = match[2];
    const user = users?.find((u) => u.id === userId);
    parts.push({
      type: "mention",
      name: fullName,
      userId,
      user,
    });
    lastIndex = match.index + match[0].length;
  }

  // Add remaining text
  if (lastIndex < content.length) {
    parts.push({ type: "text", value: content.slice(lastIndex) });
  }

  // If no mentions found, return plain text
  if (parts.length === 0) {
    return <span>{content}</span>;
  }

  return (
    <span>
      {parts.map((part, i) => {
        if (part.type === "text") {
          return <span key={i}>{part.value}</span>;
        }
        return (
          <span
            key={i}
            data-testid={`mention-tag-${part.userId}`}
            className="inline-flex items-center bg-blue-50 text-blue-700 font-semibold text-sm px-1 py-0.5 rounded-sm mx-0.5 border border-blue-200"
          >
            @{part.name}
          </span>
        );
      })}
    </span>
  );
}
